/**
 * @function modifyGoodDataFilterContext
 *
 * This function is used to tell GoodData to change the filter context.  Used for applying filters to 
 * the dashboard despite the fact we dont own or control them
 *
 * @param {string} name - The given name of the iframe that houses the GoodData dashboard who's filter
 * context you want to change.
 * @param {object[]} filterContext - The new filter context.  Usually a label and a value but dates can be to and from.
 *
 * @return {void}
 *
 * @example
 *
 *         modifyGoodDataFilterContext(YOUR_EDU_VS_NETWORK_DASHBOARD_NAME, [
 *           {
`*            label: DATE_FILTER_LABEL,
 *             from: fromDate,
 *             to: toDate,
 *             type: "date"
 *           }
 *         ]);
 */
export const modifyGoodDataFilterContext = (
  name: string,
  filterContext: any[]
) => {
  const iframe = document.getElementById(name) as HTMLIFrameElement;
  if (iframe) {
    const dashboardWindow = iframe.contentWindow;
    dashboardWindow.postMessage(
      JSON.stringify({ gdc: { setFilterContext: filterContext } }),
      "*"
    );
  }
};
